import { action } from 'typesafe-actions';
import { SearchHistory, SearchTypes } from './types';

export const searchChange = (value: string) => action(SearchTypes.SEARCH_CHANGE, value);
export const searchClear = () => action(SearchTypes.SEARCH_CLEAR);
export const searchSubmit = () => action(SearchTypes.SEARCH_SUBMIT);
export const getSearchHistoryRequest = () => action(SearchTypes.GET_SEARCH_HISTORY_REQUEST);
export const getSearchHistorySuccess = (listOfSearchHistory: SearchHistory[]) => action(SearchTypes.GET_SEARCH_HISTORY_SUCCESS, { listOfSearchHistory });
export const getSearchHistoryFailure = () => action(SearchTypes.GET_SEARCH_HISTORY_FAILURE);
export const deleteSearchHistoryRequest = () => action(SearchTypes.DELETE_SEARCH_HISTORY_REQUEST);
export const deleteSearchHistorySuccess = () => action(SearchTypes.DELETE_SEARCH_HISTORY_SUCCESS);
export const deleteSearchHistoryFailure = () => action(SearchTypes.DELETE_SEARCH_HISTORY_FAILURE);
export const getSearchSuggestionsRequest = (value: string) => action(SearchTypes.GET_SEARCH_SUGGESTIONS_REQUEST, value);
export const getSearchSuggestionsSuccess = (listOfSuggestions: string[]) => action(SearchTypes.GET_SEARCH_SUGGESTIONS_SUCCESS, { listOfSuggestions });
export const getSearchSuggestionsFailure = () => action(SearchTypes.GET_SEARCH_SUGGESTIONS_FAILURE);
export const clearSearchSuggestions = () => action(SearchTypes.CLEAR_SUGGESTIONS_LIST);
